export default {
	name: 'FormError',
	template: `
	<strong class="input-error">
		<slot />
	</strong>
	`
}